module.exports = __webpack_public_path__ + "img/163483.b63f049a.jpg";